import { render, staticRenderFns } from "./trajectory.vue?vue&type=template&id=649d9628&scoped=true&"
import script from "./trajectory.vue?vue&type=script&lang=js&"
export * from "./trajectory.vue?vue&type=script&lang=js&"
import style0 from "./trajectory.vue?vue&type=style&index=0&id=649d9628&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649d9628",
  null
  
)

export default component.exports